import { useMemo } from 'react';

import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

const md = new MarkdownIt({
    html: true,
    breaks: true,
    linkify: true,
    typographer: true
});

const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
};

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    tokens[idx].attrPush(['target', '_blank']);
    tokens[idx].attrPush(['rel', 'noopener noreferrer']);
    return defaultRender(tokens, idx, options, env, self);
};


export default function ViewMarkdownReview({ markdown }) {
    const sanitizedHtml = useMemo(() => {
        const processedMarkdown = markdown;
        const rawHtml = md.render(processedMarkdown);
        DOMPurify.addHook('afterSanitizeAttributes', function (node) {
            if (node.tagName === 'A') {
                node.setAttribute('target', '_blank');
                node.setAttribute('rel', 'noopener noreferrer');
            }
        });
        const sanitized = DOMPurify.sanitize(rawHtml, {
            ADD_ATTR: ['target'],
        });
        return sanitized;
    }, [markdown]);

    return (
        <div className="view-markdown">
            <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
        </div>
    );
}